var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercentBg = function SvgPercentBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 61,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "M24.739 11.396c2.144-4.373 8.378-4.373 10.522 0a5.86 5.86 0 0 0 6.525 3.142c4.756-1.05 8.643 3.824 6.561 8.227a5.86 5.86 0 0 0 1.612 7.06c3.786 3.064 2.399 9.142-2.342 10.26a5.86 5.86 0 0 0-4.515 5.661c-.035 4.871-5.651 7.576-9.481 4.566a5.86 5.86 0 0 0-7.242 0c-3.83 3.01-9.446.305-9.48-4.565a5.86 5.86 0 0 0-4.516-5.662c-4.74-1.118-6.128-7.196-2.342-10.26a5.86 5.86 0 0 0 1.612-7.06c-2.082-4.403 1.804-9.277 6.56-8.227a5.86 5.86 0 0 0 6.525-3.142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.707 23.96a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0M35 37.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4M25 27.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
export default SvgPercentBg;